import GameFooter from './game-footer';

export default GameFooter;